import { Link } from "react-router-dom";

function Footer() {
    return (
        <footer className=" text-white py-5 rounded-0" style={{ maxWidth: '100%' }}>
            <div className="container">
                <div className="row row-cols-2 row-cols-md-6 g-4">

                    <div>
                        <h6 className="text-uppercase fw-bold mb-3"  style={{ color: "#FF7F1F" }}>Company</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/about" className="text-white text-decoration-none">About Us</Link></li>
                            <li><Link to="/careers" className="text-white text-decoration-none">Careers</Link></li>
                            {/* <li><a href="#press" className="text-white text-decoration-none">Press</a></li> */}
                            <li><Link to="/blog" className="text-white text-decoration-none"> Blog </Link></li>
                        </ul>
                    </div>

                     <div>
                        <h6 className="text-uppercase fw-bold mb-3"   style={{ color: "#FF7F1F" }}>RoloShield</h6>
                        <ul className="list-unstyled">
                            <li><a href="https://shield.rolotransit.com/#products" className="text-white text-decoration-none"> RoloShield Car </a></li>
                            <li><a href="https://shield.rolotransit.com/#products" className="text-white text-decoration-none">RoloShield Bike </a></li>
                            <li><a href="https://shield.rolotransit.com/#products" className="text-white text-decoration-none">RoloShield Transport </a></li>
                             <li><a href="https://shield.rolotransit.com/#products" className="text-white text-decoration-none">RoloShield Portable </a></li>
                        </ul>
                    </div>

                    <div>
                        <h6 className="text-uppercase fw-bold mb-3"   style={{ color: "#FF7F1F" }}>Services</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/book-ride" className="text-white text-decoration-none">Our Fleet</Link></li>
                            <li><Link to="/become-driver" className="text-white text-decoration-none">Become Driver</Link></li>
                            {/* <li><Link to="/pricing" className="text-white text-decoration-none">Pricing</Link></li> */}
                        </ul>
                    </div>

                    <div>
                        <h6 className="text-uppercase fw-bold mb-3"   style={{ color: "#FF7F1F" }}>Support</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/faq" className="text-white text-decoration-none">FAQ</Link></li>
                            <li><Link to="/help-center" className="text-white text-decoration-none">Help Center</Link></li>
                            <li><Link to="/safety" className="text-white text-decoration-none">Safety</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h6 className="text-uppercase fw-bold mb-3"   style={{ color: "#FF7F1F" }}>Legal</h6>
                        <ul className="list-unstyled">
                            <li><Link to="/terms" className="text-white text-decoration-none">Terms & Conditions</Link></li>
                            <li><Link to="/privacy" className="text-white text-decoration-none">Privacy Policy</Link></li>
                            {/* <li><a href="#licenses" className="text-white text-decoration-none">Licenses</a></li> */}
                        </ul>
                    </div>

                    <div>
                        <h6 className="text-uppercase fw-bold mb-3"   style={{ color: "#FF7F1F" }}>Social Media</h6>
                        <ul className="list-unstyled">
                  
                            <li><a href="https://x.com/RoloTransit" target="_blank" rel="noreferrer" className="text-white text-decoration-none">Twitter</a></li>
                            <li><a href="https://www.instagram.com/rolotransit" target="_blank" rel="noreferrer" className="text-white text-decoration-none">Instagram</a></li>
                            <li><a href="https://www.facebook.com/rolotransit" target="_blank" rel="noreferrer" className="text-white text-decoration-none">Facebook</a></li>
                            <li><a href="https://www.linkedin.com/company/rolo-transit-platforms-pvt-ltd/" target="_blank" rel="noreferrer" className="text-white text-decoration-none">LinkedIn</a></li>
                        </ul>
                    </div>

                </div>

                <div className="text-center pt-4 mt-4 border-top border-secondary">
                    <small>&copy; {new Date().getFullYear()} Rolo. All rights reserved.</small>
                </div>

                <div className="pt-4 mt-3">
                    <p className="text-white-50" style={{ fontSize: '11px', lineHeight: '1.6', textAlign: 'justify' }}>
                        The information provided by Rolo Transit Platforms Private Limited ("we," "us," or "our") on https://rolotransit.com (the "Site") and our mobile application is for general informational purposes only. All information on the Site and our mobile application is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site or our mobile application. UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR OUR MOBILE APPLICATION OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE AND OUR MOBILE APPLICATION. YOUR USE OF THE SITE AND OUR MOBILE APPLICATION AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE AND OUR MOBILE APPLICATION IS SOLELY AT YOUR OWN RISK.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;